// const apiUrl = 'http://192.168.0.212:8035/api/v1/';//测试域名
// const apiUrl = 'http://192.168.0.16/kx_library/public/api/v1/';//测试域名
// const apiUrl = 'http://proxy.jiankanghao.net:50070/api/v1/';//测试域名
const apiUrl = 'https://api.kanguji.com/api/v1/';//测试域名

export default apiUrl



// WEBPACK FOOTER //
// ./src/util/api.js